import { splitDateStringToParts } from "../../util/date";
import InputItem from "./InputItem";
import InputRadio from "./InputRadio";
import ValidationErrorMessage from "./ValidationErrorMessage";
import IsRequired from "./common/IsRequired";

export default function HalvaarInput<U>({
  config,
  formik,
  disabled,
}: FormikControlProps<U>) {
  const { id, label, isRequired } = config;
  const { values, setTouched, setFieldValue, errors, touched } = formik;

  const setThisTouched = () => setTouched({ ...touched, [id]: true });
  const value = values[id] ? values[id].toString() : "-01-01";

  const parts = splitDateStringToParts(value);
  const [yearPart, monthPart, datePart] = parts;
  const isFirstOfJanuary = () => monthPart === "01" && datePart === "01";
  const isFirstOfJuly = () => monthPart === "07" && datePart === "01";
  const setFirstOfJanuary = () => setFieldValue(id, `${yearPart}-01-01`, true);
  const setFirstOfJuly = () => setFieldValue(id, `${yearPart}-07-01`, true);
  const setYear = (year: string) =>
    setFieldValue(
      id,
      `${year.padStart(4, "0")}-${monthPart}-${datePart}`,
      true,
    );

  return (
    <>
      <label className="form-label">
        {label}
        {isRequired && <IsRequired />}
      </label>
      <div className="w-100 d-flex align-items-center">
        <InputRadio
          className="flex-shrink-0"
          disabled={disabled}
          label="1. halvår"
          name="filialRadio"
          id="filialRadio1"
          checked={value ? isFirstOfJanuary() : true}
          onChange={() => {
            setFirstOfJanuary();
          }}
          // onBlur={() => setThisTouched()}
        />
        <InputRadio
          className="flex-shrink-0"
          disabled={disabled}
          label="2. halvår"
          name="filialRadio"
          id="filialRadio2"
          checked={isFirstOfJuly()}
          onChange={() => {
            setFirstOfJuly();
          }}
          // onBlur={() => setThisTouched()}
        />

        <InputItem
          disabled={disabled}
          className={
            formik.touched[id] && (errors as any)[id] ? " is-invalid" : ""
          }
          type="number"
          label=""
          id={id + "-halvaar-aar-input"}
          placeholder={"fx. " + new Date().getFullYear().toString()}
          value={yearPart.replace(/^0+/, "")}
          setValue={(value) => setYear(value.slice(0, 4))}
          onBlur={() => setThisTouched()}
        />
      </div>
      <ValidationErrorMessage
        touched={formik.touched[id]}
        errorMessage={(errors as any)[id]}
      />
    </>
  );
}
